export const DEFAULT_STALE_DATA_MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;

export const isStale = (
  questionTimestamp,
  referenceTimestamp,
  staleAge = DEFAULT_STALE_DATA_MAX_AGE_MS
) => {
  if (questionTimestamp == null || referenceTimestamp == null) {
    return false;
  }
  return +questionTimestamp < +referenceTimestamp - staleAge;
};
